<template>
  <span :title="row[col.field]" class="wrap">
    {{row[col.field]}}
    <i class="el-icon-s-opportunity icon" @click="onClick"/>
  </span>
</template>

<script>
export default {
  name: 'TemplateFilter',
  props: {
    row: { type: Object, required: true },
    col: { type: Object, required: true },
    template: { type: Object, required: true }
  },
  methods: {
    onClick () {
      this.$emit('handle', { type: 'filter', row: this.row, col: this.col })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .wrap{
    .icon{
      display none
    }
    &:hover{
      .icon{
        display inline-block
      }
    }
  }
  .icon{
    display inline-block
    position absolute
    left 0
    top 0
    bottom 0
    padding 1rem
    background-color rgba(#606266, .4)
    border-radius 0 .4rem .4rem 0
    border-left 1px solid #606266
    cursor pointer
    color white
  }
</style>
